module.exports = __webpack_public_path__ + "img/main-login.fe5c293a.jpg";